import React from 'react';
import { Loader } from '@googlemaps/js-api-loader';

import { google } from 'config/settings';

class Place extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      place: undefined,
    };

    this.tiers = {};
    this.getPlaceDetails = this.getPlaceDetails.bind(this);
    this.formatPrice = this.formatPrice.bind(this);
    this.formatType = this.formatType.bind(this);
  }

  componentDidMount() {
    if (this.props.place && this.props.place.place_id) {
      const loader = new Loader({
        apiKey: google.places.apiKey,
        version: google.places.version,
        libraries: ['places']
      });

      loader.importLibrary('places').then(({Place, PriceLevel}) => {
        this.getPlaceDetails(Place);

        this.tiers[PriceLevel.FREE] = 0;
        this.tiers[PriceLevel.INEXPENSIVE] = 1;
        this.tiers[PriceLevel.MODERATE] = 2;
        this.tiers[PriceLevel.EXPENSIVE] = 3;
        this.tiers[PriceLevel.VERY_EXPENSIVE] = 4;

      }).catch(e => {
        Bugsnag.notify(e);
      });
    }
  }

  async getPlaceDetails(Place) {
    const place = new Place({id: this.props.place.place_id});
    await place.fetchFields({ fields: ['displayName', 'photos', 'rating', 'priceLevel', 'formattedAddress', 'types'] });
    this.setState({place: place});
  }

  formatPrice(price) {
    let level = this.tiers[price];

    if (level == 0) return 'FREE';

    let p  = [1,2,3,4].map((tier) => {
      return tier <= level ? <strong key={tier}>$</strong> : "$";
    });

    return (p);
  }

  formatType(types) {
    if (types && types.length && types[0] !== 'route') {
      const type = types[0].replace(/_/g, ' ');
      return type.charAt(0).toUpperCase() + type.slice(1);
    }
  }

  render() {
    if (this.state.place) {
      const name = this.state.place.displayName;
      const types = this.state.place.types;
      const rating = this.state.place.rating;
      const price = this.state.place.priceLevel;
      const address = this.state.place.formattedAddress;
      const photos = this.state.place.photos;

      return (
        <React.Fragment>
        <div className="place-image u-pull-left">
          {photos && photos.length && <img src={photos[0].getURI({maxWidth: 160})} />}
        </div>

        <table className="place">
          <tbody>
            <tr>
              <th>{name}</th>
              {rating && <td className="rating">{rating} <sup>&#9733;</sup></td>}
            </tr>
            <tr>
              <td>{this.formatType(types)}</td>
              {price && <td className="price">{this.formatPrice(price)}</td>}
            </tr>
            {address &&
              <tr>
                <td>{address}</td>
              </tr>
            }
          </tbody>
        </table>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <div className="no-place-image u-pull-left">
            <i className="material-icons md-36 md-inactive u-pull-left">place</i>
          </div>

          <table className="place">
            <tbody>
              <tr>
                <th>No place yet</th>
              </tr>
              <tr>
                <td>Join and propose a place.</td>
              </tr>
            </tbody>
          </table>
        </React.Fragment>
      );
    }
  }
}

export default Place;
